export const padLeft = (value, length, paddingChar) => {
    value = String(value); 
  
    while (value.length < length) {
      value = paddingChar + value;
    }
  
    return value;
}

export const numberStringRangeList = (nroChequeDesde, nroChequeHasta, multiplicador) => {
  const cantidadNumeros = nroChequeHasta - nroChequeDesde + 1;
  const listaNumerica = Array.from({ length: cantidadNumeros }, (_, index) => String(nroChequeDesde + index));
  return listaNumerica.flatMap(numero => Array.from({ length: multiplicador }, () => numero));
}


export const multiplyValue = (value, multiplicador) => {
  return Array.from({ length: multiplicador }, () => value);
}

export const calcularTotal = (listaNumeros) => {
  return listaNumeros.reduce((total, numero) => total + numero, 0);
}